export const POLICY_FANATICISM_RUINS_WIN_POINTS_INCOME_BONUS = 2;

export const POLICY_FANATICISM_WIN_POINTS_CONVERSION = 3;
export const POLICY_FANATICISM_COINS_CONVERSION = 4;

export const POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D6 = 1;
export const POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D10 = 2;
export const POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D20 = 3;
export const POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D8 = 2;
export const POLICY_FANATICISM_UNIT_MELEE_BONUS_ADJACENT_TO_RUINS_D12 = 3;